module.exports = __webpack_public_path__ + "img/WavesBack.9fccf831.png";